import React from 'react';

const PhotographersPage = () => {
  return (
    <div>
      <h1>Photographers</h1>
    </div>
  );
};

export default PhotographersPage;
